<template>
  <validation-provider v-slot="validationContext" :vid="vid" :name="inputLabelText" :rules="rules" :custom-messages="customMessages" slim>
    <b-form-group
      :label-for="'input-' + id"
      :label-class="['d-inline', labelClass]"
      :class="[Object.keys(validationContext.failedRules).length !== 0 ? 'error' : null, formGroupClass]"
    >
      <template v-if="inputLabelText" #label>
        {{ inputLabelText }}
        <span v-if="requiredStar" class="text-danger">*</span>
      </template>
      <b-form-input
        :id="'input-' + id"
        v-model="displayModel"
        :state="getValidationState(validationContext)"
        :type="type"
        :placeholder="placeholder"
        :size="size"
        :autofocus="autoFocus"
        :disabled="disabled"
        :lazy="lazy"
        :name="'input-' + inputName"
        :number="numberVModel"
        :readonly="readonly"
        :class="inputClass"
        :autocomplete="autoComplete"
        :min="min"
        :max="max"
        :step="step"
        :value="value"
        trim
        data-vv-validate-on="input"
        @scroll="preventScroll($event)"
        @focusout="focusout($event)"
        @change="change($event)"
        @keypress="numbersOnly($event)"
        @keydown.enter="keydownEnter($event)"
      />
      <b-form-invalid-feedback v-if="customMessages" :id="'input-' + id" key="b-form-invalid-feedback-1" class="invalid-feedback-inline">
        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) : null }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-else :id="'input-' + id" key="b-form-invalid-feedback-2" class="invalid-feedback-inline">
        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import BaseModelEmitter from "../../../../mixins/baseModelEmitter";

export default {
  name: "BaseInput",
  mixins: [BaseModelEmitter],
  props: {
    id: {
      type: String,
      default: () => Math.floor(Math.random() * 100000).toString(),
    },
    inputLabelText: {
      type: String,
      default: "",
    },
    state: {
      type: Boolean,
      default: false,
    },
    requiredStar: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    inputClass: {
      type: [String, Object],
      default: null,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    autoComplete: {
      type: String,
      default: "off",
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    numberVModel: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    formGroupClass: {
      type: [String, Object],
      default: null,
    },
    customMessages: {
      type: Object,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: [Number, String],
      default: null,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    labelClass: {
      type: [String, Object],
      default: null,
    },
    //eslint-disable-next-line vue/require-default-prop
    inputModel: null,
    rules: {
      // type: Object,
      type: [String, Object],
      default: null,
    },
    vid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputName: null,
    };
  },
  mounted() {
    this.inputNameFormat();
  },
  methods: {
    preventScroll(event) {
      event.preventDefault();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    focusout(event) {
      this.inputToUpperCase(event);
      this.$emit("focusout", event);
    },
    change(event) {
      this.inputToUpperCase(event);
      this.$emit("change", event);
    },
    inputNameFormat() {
      if (this.inputLabelText !== null) {
        this.inputName = this.inputLabelText
          .split(" ")
          .join("-")
          .replace(/Ğ/gim, "G")
          .replace(/Ü/gim, "U")
          .replace(/Ş/gim, "S")
          .replace(/İ/gim, "I")
          .replace(/Ö/gim, "O")
          .replace(/Ç/gim, "C")
          .replace(/ğ/gim, "g")
          .replace(/ü/gim, "u")
          .replace(/ş/gim, "s")
          .replace(/ı/gim, "i")
          .replace(/ö/gim, "o")
          .replace(/ç/gim, "c")
          .toLowerCase();
      } else {
        this.inputName = "name-" + this.id;
      }
    },
    validationTextFormat(text) {
      let fiterText = text.split(" ");
      let returnText = fiterText[0];

      for (let i = 1; i < fiterText.length; i++) {
        const firstChar = fiterText[i].charAt(0);
        returnText += " " + (firstChar === "İ" ? "i" : firstChar === "I" ? "ı" : firstChar.toLowerCase()) + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    numbersOnly(evt) {
      if (this.type === "number") {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
    inputToUpperCase(event) {
      if (this.type === "text" && event && event.target && event.target.value && typeof event.target.value === "string") {
        const inputClasses = event.target.className;
        // password değilse
        if (event.target.classList.contains("emailInput")) {
          event.target.value = event.target.value.toLocaleLowerCase("tr-TR");
          this.displayModel = event.target.value;
        } else if (inputClasses.indexOf("passwordInput") === -1) {
          event.target.value = event.target.value.toLocaleUpperCase("tr-TR");
          this.displayModel = event.target.value;
        }
      }
    },
    keydownEnter(event) {
      this.inputToUpperCase(event);
    },
  },
};
</script>

<style lang="scss" scoped>
.emailInput {
  text-transform: none;
}
</style>
